<template>
  <!-- Centered empty state for a Courses tab (illustration + heading + message + optional CTA). -->
  <div class="courses-empty">
    <img :src="image" alt="" class="courses-empty__art" />
    <div class="courses-empty__text">
      <p class="courses-empty__title">{{ title }}</p>
      <p v-if="message" class="courses-empty__message">{{ message }}</p>
      <div v-if="ctaLabel" class="courses-empty__cta-wrap">
        <v-btn variant="flat" rounded class="courses-empty__cta font-weight-bold" @click="$emit('cta')">
          {{ ctaLabel }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import emptyTranscript from '@/assets/images/empty-transcript.svg';

export default defineComponent({
  name: 'CoursesEmptyState',
  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      default: ''
    },
    /** Illustration URL; defaults to the transcript stamp illustration. */
    image: {
      type: String,
      default: emptyTranscript
    },
    /** When set, renders a gold CTA button that emits `cta` on click. */
    ctaLabel: {
      type: String,
      default: ''
    }
  },
  emits: ['cta']
});
</script>

<style lang="scss" scoped>
.courses-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 40px 24px;

  &__art {
    width: 205px;
    max-width: 100%;
    height: auto;
    margin-bottom: 8px;
  }

  &__text {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 656px;
  }

  &__title {
    margin: 0;
    font-family: Arial, sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: -0.48px;
    color: #000;
  }

  &__message {
    margin: 0;
    font-family: Arial, sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: #000;
  }

  &__cta-wrap {
    display: flex;
    justify-content: center;
  }

  // Standard gold CTA (Figma: 36px pill, Arial bold 16px). v-btn's casing and
  // typography defaults are pinned here rather than left to ambient global CSS,
  // so it renders the same wherever it is mounted (app, Storybook, tests).
  &__cta {
    background-color: var(--asu-primary-colors-asu-gold, #ffc627) !important;
    color: var(--asu-text-colors-primary-text, #191919) !important;
    height: 36px !important;
    padding: 0 24px !important;
    border-radius: 100px;
    font-family: Arial, sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 22.4px;
    text-transform: none;
    letter-spacing: normal;
  }
}
</style>
